import { BlackFridaySelectionDTO } from 'api-models'
import { useEffect, useState } from 'react'
import { BlackFridayOffers } from 'services/user/black-friday-offer'
import { parseError } from 'utils/errors'

export const useBlackFridaySelection = (input: {
	accountId?: string
	tier: string | null
	priceId?: string | null
	spend: number
	yearly: boolean
	onboarding?: boolean
	enabled?: boolean
	busy?: boolean
}) => {
	const fingerprint = JSON.stringify([
		input.accountId,
		input.tier,
		input.priceId,
		input.spend,
		input.yearly
	])
	const [state, setState] = useState<{
		fingerprint: string
		data?: BlackFridaySelectionDTO
		receivedAt?: number
		error?: string
	}>({ fingerprint: '' })
	const [expired, setExpired] = useState(false)
	useEffect(() => {
		if (
			input.enabled === false ||
			input.busy ||
			!input.accountId ||
			!input.tier ||
			(input.yearly && input.tier !== 'custom' && !input.priceId)
		)
			return
		let current = true
		setState({ fingerprint: '' })
		void BlackFridayOffers.selection(input.accountId, !!input.onboarding, {
			tier: input.tier,
			price_id: input.priceId || null,
			spend: input.spend,
			yearly: input.yearly
		})
			.then((data) => {
				if (current)
					setState({ fingerprint, data, receivedAt: performance.now() })
			})
			.catch((error) => {
				if (current) setState({ fingerprint, error: parseError(error) })
			})
		return () => {
			current = false
		}
	}, [fingerprint, input.enabled, input.onboarding, input.busy])
	useEffect(() => {
		if (!state.data || state.receivedAt == null) return
		const remaining =
			Date.parse(state.data.claim_deadline) -
			Date.parse(state.data.server_now) -
			(performance.now() - state.receivedAt)
		setExpired(remaining <= 0)
		if (remaining <= 0) return
		const timer = setTimeout(
			() => setExpired(true),
			Math.min(remaining + 1, 2147483647)
		)
		return () => clearTimeout(timer)
	}, [state.data, state.receivedAt])
	const current = state.fingerprint === fingerprint ? state : undefined
	const selectionId = current?.data?.selection_id || undefined
	const active =
		!!selectionId && input.yearly && (input.tier !== 'custom' || !expired)
	return {
		selectionId: active ? selectionId : undefined,
		quote: active ? current?.data?.quote : null,
		active,
		showBanner: !!current?.data?.available && !expired,
		loading:
			input.enabled !== false && !!input.accountId && !!input.tier && !current,
		error: current?.error
	}
}
